import React, { useCallback, useMemo, useReducer } from 'react';

import dealerRequestModalConstants    from './dealerRequestModal.constants';
import DealerRequestModalContext      from './dealerRequestModal.context';
import dealerRequestModalReducer      from './dealerRequestModal.reducer';
import dealerRequestModalInitialState from './dealerRequestModal.state';

/**
 * @type {React.FC}
 */

const DealerRequestModalProvider = function({
  children,
  value = dealerRequestModalInitialState,
}) {
  const [state, dispatch] = useReducer(dealerRequestModalReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: dealerRequestModalConstants.HIDE_MODAL });
  }, [dispatch]);
  const showModal = useCallback(() => {
    dispatch({
      type: dealerRequestModalConstants.SHOW_MODAL,
    });
  }, [dispatch]);

  const context = useMemo(() => (
    {
      ...state,
      hideModal,
      showModal,
    }), [hideModal, showModal, state]);

  return (
    <DealerRequestModalContext.Provider value={context}>
      {children}
    </DealerRequestModalContext.Provider>
  );
};

export default DealerRequestModalProvider;